import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'

export default (): [
  LanguageCode.FI,
  LanguageCode.SV,
  LanguageCode.AF,
  LanguageCode.EN
] => {
  return [LanguageCode.FI, LanguageCode.SV, LanguageCode.AF, LanguageCode.EN]
}
